import { gql } from "graphql-tag";

export const GET_ASSET_CATEGORIES = gql`
  query GetAssetCategories(
    $pagination: PaginationInput
    $filter: AssetCategoryFilterInput
    $sort: AssetCategorySortInput
  ) {
    assetCategories(pagination: $pagination, filter: $filter, sort: $sort) {
      data {
        id
        name
        description
        sortingOrder
        accountId
        createdAt
        updatedAt
      }
      meta {
        page
        limit
        total
        totalPages
        hasNext
        hasPrev
      }
    }
  }
`;

export const GET_ASSET_CATEGORY = gql`
  query GetAssetCategory($id: ID!) {
    assetCategory(id: $id) {
      id
      name
      description
      sortingOrder
      accountId
      createdAt
      updatedAt
    }
  }
`;
